import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import { ActionTimeControl } from '../../ActionTimeControl/ActionTimeControl';
import { MoreVertIconContrast } from '../../../icons/MoreVertIconContrast';
import { getCurrentSendedTakeOff } from '../../../selectors/sended-data';
import { Clock } from '../../../icons';
import { getTimeFormat } from '../../../service/NavPointsUtils';
import { getTimeDiff } from '../../../service/DateTimeUtils';
import { getFirstLeg, getPrevLeg, getUserLegs } from '../../../selectors/screen';
import { onChangeTime } from '../../../actions/take-off';

export const StartWorkTime = memo(() => {
    const dispatch = useDispatch();
    const { value, timeWorkRest, defaultValue, isFirstLeg, ofpId } = useSelector((state) => {
        const currentLegId = get(state, 'screen.currentLeg');
        const takeOff = getCurrentSendedTakeOff(state);
        const prevLegId = get(getPrevLeg(state), 'id');
        const userLegs = getUserLegs(state);
        const isPrevLegForUser = userLegs[prevLegId] !== undefined;
        const endWorkTime = isPrevLegForUser && get(state, `sendedData.[${prevLegId}].landing.endWorkTime`);
        const firstLeg = getFirstLeg(state) || {};
        const ofpId = get(state, `sendedData[${currentLegId}].ofpId`);

        return {
            value: takeOff.startWorkTime,
            timeWorkRest: getTimeFormat(getTimeDiff(endWorkTime, takeOff.startWorkTime)),
            defaultValue: endWorkTime,
            ofpId: +ofpId,
            isFirstLeg: firstLeg.id === currentLegId || (firstLeg.id === prevLegId && !isPrevLegForUser),
        };
    }, shallowEqual);
    const { t: translate } = useTranslation();

    const summary = React.useMemo(() => {
        const res = [];

        if (timeWorkRest) {
            res.push({
                title: translate('flightInfoPage.restTime'),
                value: timeWorkRest,
            });
        }

        return res;
    }, [timeWorkRest, translate]);

    const handleChangeTime = React.useCallback((name, value) => {
        dispatch(onChangeTime(name, value));
    }, []);

    const title = isFirstLeg ? translate('flightInfoPage.startDutyTime') : translate('flightInfoPage.startLegTime');
    const text = isFirstLeg ? translate('flightInfoPage.dutyTimeStartedOn') : translate('flightInfoPage.startedLegOn');

    return (
        <ActionTimeControl
            {...{ title, text, value, defaultValue, summary }}
            buttonName={title}
            state="ENTER_COMPLETED"
            disabled={!ofpId}
            iconButton={<Clock width="20" height="20" />}
            iconMenuImg={<MoreVertIconContrast isContrast={true} />}
            name="startWorkTime"
            onChange={handleChangeTime}
            dialogText={!isFirstLeg ? translate('messages.currentLegNotFirstInFlightTask') : ''}
        />
    );
});
